import { useEffect, useState } from 'react'
import NavbarNotAuth from '../userNotAuth/components/navbarNotAuth'
import {NavbarTopAdmin, NavbarBottomAdmin} from '../admin/components'
import axios from 'axios'
import DivBottom from '../userNotAuth/components/divBottom'
import { useNavigate } from 'react-router-dom'

function MyEventiTable() {
    const navigate = useNavigate()
    const idUser = localStorage.getItem('idUser')
    const [eventi, setEventi] = useState([])
    const [inputValue, setInputValue] = useState('')
    const [cercaEvento, setCercaEvento] = useState([])
    const [deleteEvento, setDeleteEvento] = useState(null)

    async function my_eventi() {
        try {
            const res = await axios.get(`/getEventiById/${idUser}`)
            setEventi(res.data)
        } catch (err) { console.log(err) }
    }

    function handleInputChange(e) {
        const { value } = e.target
        setInputValue(value)
        let xc = []
        if (value)
            xc = eventi.filter(x => x.titolo.toLowerCase().includes(value.toLowerCase()))
        setCercaEvento(xc)
    }

    async function deleteEvent(e) {
        if (deleteEvento[0].img) {
            axios.delete(`/delete-img/${deleteEvento[0].img}`, { data: { folder: '' } })
        }
        if (deleteEvento[0].video) {
            axios.delete(`/delete-video/${deleteEvento[0].video}`)
        }
        const res = await axios.post(`/deleteEventi/${'elimina'}`, [deleteEvento[0].id])
        if (res.data === 'success') {
            setEventi(eventi.filter(x => x.id !== deleteEvento[0].id))
        }
    }

    useEffect(() => {
        if (!idUser) navigate('/')
        my_eventi()
    }, [])
    // useEffect(() => { console.log(eventi) }, [eventi])
    return (<>
        {localStorage.getItem('email') === 'maladmin@admin.it' ? <div><NavbarTopAdmin /> <NavbarBottomAdmin /></div>
            : <NavbarNotAuth />}
        <br />
        <div style={{ marginBottom: '5px' }}>
            <div className='mt-3'>
                <h2 className='mt-5 p-3 text-center'>I MIEI EVENTI</h2>
                {eventi.length === 0 ?
                    <h2 className='m-5 fw-semibold'>Non hai nessun evento da mostrare</h2>
                    :
                    <div style={{ fontSize: '14px', margin: '1em' }}>
                        <div>
                            <span className='ballColor'></span><div className='ballText'>evento in line</div>
                            <span className='ballColor' style={{ backgroundColor: 'orange' }}></span><div className='ballText'>evento in esame</div>
                            <span className='ballColor' style={{ backgroundColor: 'black' }}></span><div className='ballText'>evento annullato</div>
                            <span className='ballColor' style={{ backgroundColor: 'red' }}></span><div className='ballText'>evento disapprovato</div>
                        </div>
                        {/* -------------------- INPUT CERCA EVENTO --------------- */}
                        <div className='mt-3 w-100'>
                            <label>Titolo</label>
                            <input type='text' name='titolo' onChange={handleInputChange} placeholder='cerca evento' value={inputValue}
                                className='pe-5 ms-3 w-75' />
                            {inputValue && (
                                <button type="button" onClick={() => { setInputValue(''); setCercaEvento('') }}>
                                    &times;
                                </button>
                            )}
                        </div>
                        {cercaEvento.length !== 0 &&
                            <div style={{ border: '1px solid gray', width: '95%', fontSize: 'small', margin: '1em 5px' }}>
                                {cercaEvento.map(elem => (
                                    <div style={{ padding: '3px 5px' }} >{elem.titolo}
                                        <span className='float-end'>
                                            <span style={{ color: 'red', cursor: 'pointer' }} onClick={() => {
                                                navigate('/editEvento1', { state: { idEvento: elem.id } })
                                            }}>
                                                Edit
                                            </span>
                                            <span style={{ color: 'navy', cursor: 'pointer', marginLeft: '8px' }} onClick={() => {
                                                navigate(`/eventiDetails/${elem.id}`)
                                            }}>Dettagli
                                            </span>
                                            <span style={{ color: 'black', cursor: 'pointer', marginLeft: '8px' }} onClick={() => {
                                                setDeleteEvento(eventi.filter(x => x.id === elem.id))
                                            }}>Elimina
                                            </span>
                                        </span>
                                    </div>
                                ))
                                }
                            </div>
                        }
                    </div>
                }
                <table className='table mt-5'>
                    <thead>
                        <tr style={{ fontSize: '13px' }}>
                            <th></th>
                            <th className='titolo'>Evento</th>
                            <th className='thDesk'>Tipo evento</th>
                            <th>Prov</th>
                            <th>Inizio</th>
                            <th className='thDesk'>Fine</th>
                            <th className='thDesk'>Edit</th>
                            <th className='thDesk'>Details</th>
                            <th className='thDesk'>Elimina</th>
                        </tr>
                    </thead>
                    <tbody>
                        {eventi.map(evento => {
                            let flag
                            switch (evento.accettazione) {
                                case 'true': flag = 'lawngreen'; break
                                case 'false': flag = 'orange'; break
                                case 'null': flag = 'black'; break
                                case 'rejection': flag = 'red'; break
                                default: flag = 'transparent'
                            }

                            return (
                                <tr key={evento.id} style={{ cursor: 'pointer', fontSize: '12px' }}>
                                    <td><div style={{
                                        borderRadius: '50px',
                                        width: '7px',
                                        height: '7px',
                                        marginTop: '8px',
                                        backgroundColor: flag
                                    }}></div>
                                    </td>
                                    <td>{evento.titolo}</td>
                                    <td className='thDesk'>{evento.tipologia}</td>
                                    <td>{evento.provincia}</td>
                                    <td>{evento.dataInizio.split("-").reverse().join("-")}</td>
                                    <td className='thDesk'>{evento.dataFine.split("-").reverse().join("-")}</td>
                                    <td onClick={() => {
                                        navigate('/editEvento1', {
                                            state: { idEvento: evento.id }
                                        })
                                    }} style={{ color: 'red' }}>Edit
                                    </td>
                                    <td style={{ color: 'blue' }} onClick={() => { navigate(`/eventiDetails/${evento.id}`) }}>Guarda</td>
                                    <td onClick={() => { setDeleteEvento(eventi.filter(x => x.id === evento.id)) }}>Elimina</td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
            <div style={{ margin: '2em' }}>
                <button className='btn btn-secondary' onClick={() => { navigate('/', { replace: true }) }}>⇐ Home
                </button>
            </div>
        </div>

        {/* ----------------------- BANNER ELIMINA EVENTO ------------------------- */}
        {deleteEvento &&
            <div className='position-fixed start-50 translate-middle-x text-bg-dark p-3 w-90 w-md-50 w-lg-33 rounded'
                style={{ bottom: '55vh', zIndex: '1' }} >
                Eliminare {deleteEvento[0].titolo}
                <p className='mt-5 text-center p-1'>
                    <button type='button' onClick={() => { deleteEvent('elimina') }}>CONFERMA</button>
                    <button className='ms-1' type='button' onClick={() => { setDeleteEvento(null) }}>ANNULLA</button>
                </p>
            </div>
        }
        <DivBottom />
    </>)
}
export default MyEventiTable